var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDispatchLaterTooltip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.913 7.94a.65.65 0 0 0-.8.453A5.18 5.18 0 0 1 8.8 11.911a5.152 5.152 0 0 1-3.97-.237 5.156 5.156 0 0 1-2.636-2.983 5.15 5.15 0 0 1 .24-3.966 5.158 5.158 0 0 1 2.975-2.637 5.19 5.19 0 0 1 5.51 1.381h-.695a.65.65 0 0 0 0 1.3h2.133a.65.65 0 0 0 .65-.65V1.974a.65.65 0 1 0-1.3 0v.435A6.498 6.498 0 0 0 4.983.859a6.452 6.452 0 0 0-3.719 3.297 6.444 6.444 0 0 0-.3 4.96 6.448 6.448 0 0 0 3.297 3.727 6.46 6.46 0 0 0 4.964.297 6.48 6.48 0 0 0 4.142-4.401.65.65 0 0 0-.454-.8z",
    fill: "gray"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88 4.12a.65.65 0 0 0-.65.65v2.665c0 .228.12.44.316.557L8.61 9.228a.649.649 0 1 0 .668-1.116L7.531 7.066V4.77a.65.65 0 0 0-.65-.65z",
    fill: "gray"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispatchLaterTooltip);
export default __webpack_public_path__ + "static/media/dispatch_later_tooltip.d928cd6fb4ed7d29dcfc4987d4255225.svg";
export { ForwardRef as ReactComponent };